import config from 'config';

const LOAD_TEAM = 'football/competitions/LOAD_TEAM';
const LOAD_TEAM_SUCCESS = 'football/competitions/LOAD_TEAM_SUCCESS';
const LOAD_TEAM_FAIL = 'football/competitions/LOAD_TEAM_FAIL';

const initialState = {
  loaded: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_TEAM:
      return {
        ...state,
        loading: true
      };
    case LOAD_TEAM_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        teamData: action.result
      };
    }
    case LOAD_TEAM_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    default:
      return state;
  }
}

export function isLoading(globalState) {
  return globalState.football
      && globalState.football.competition
      && globalState.football.competition.loading;
}

export function loadTeam(teamId, fixturesResults) {
  const params = {
    results_only: fixturesResults == "results"
  }

  return {
    types: [LOAD_TEAM, LOAD_TEAM_SUCCESS, LOAD_TEAM_FAIL],
    promise: client => client.get(`${config.api.football.teams}/${teamId}`, {params})
  };
}



// WEBPACK FOOTER //
// ./modules/Football/reducers/team.js